import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type AccountLogoRemovalFailedAction = {
	type: 'ACCOUNT_LOGO_REMOVAL_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): AccountLogoRemovalFailedAction => ({
	type: 'ACCOUNT_LOGO_REMOVAL_FAILED',
	payload,
});
